import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

const Breadcrumb = (props) => {
  const {
    title,
    previousPathname,
    route,
    style,
    itemNavigator,
    item_ID,
    location,
    isItemLive,
    eventType_ID,
    event_ID,
  } = props;

  const prevNextStyles = {
    height: "100%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  };

  const linkStyles = {
    color: "#6C757D",
    display: "inline",
    cursor: "pointer",
  };

  const [prev, setPrev] = useState(item_ID);
  const [next, setNext] = useState(item_ID);

  useEffect(() => {
    if (item_ID && itemNavigator.length > 0) {
      const thisItemIndex = itemNavigator.findIndex((x) => x === item_ID);

      let prev = thisItemIndex - 1;
      let next = thisItemIndex + 1;
      if (prev < 0) prev = itemNavigator.length - 1;
      if (next > itemNavigator.length - 1) next = 0;
      setPrev(itemNavigator[prev]);
      setNext(itemNavigator[next]);
    }
  });

  return (
    <div className="breadcrumb-section" style={style}>
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <nav aria-label="breadcrumb" className="theme-breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link
                    to={previousPathname ? route : `${process.env.PUBLIC_URL}`}
                  >
                    <span className="link-hover">
                      {previousPathname ? previousPathname : "Home"}
                    </span>
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {title}
                </li>
              </ol>
            </nav>
          </div>
          {isItemLive && (
            <div className="col-md-6 d-flex align-items-center justify-content-end">
              <li className="breadcrumb-item">
                {eventType_ID === 2 ? ( //SIMULCAST
                  <a
                    href={`${process.env.REACT_APP_SIMULCAST_BASE_URL}/auction/${event_ID}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="link-hover">Return To Live Auction</span>
                  </a>
                ) : (
                  <Link to="/live-auction">
                    <span className="link-hover">Return To Live Auction</span>
                  </Link>
                )}
              </li>
            </div>
          )}
          {itemNavigator.length > 0 &&
            location.includes("/item") &&
            !isItemLive && (
              <div className="col-md-6">
                <div style={prevNextStyles}>
                  <Link
                    to={{
                      pathname: `/item/${prev}`,
                    }}
                    style={linkStyles}
                  >
                    <span className="link-hover">
                      <i className="fa fa-caret-left mr-1"></i>Previous Item
                    </span>
                  </Link>
                  <Link
                    to={{ pathname: `/item/${next}` }}
                    className="ml-3"
                    style={linkStyles}
                  >
                    <span className="link-hover">
                      Next Item<i className="fa fa-caret-right ml-1"></i>
                    </span>
                  </Link>
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  itemNavigator: state.search.itemNavigator,
  item_ID: state.auction.item.item_ID,
  location: state.router.location.pathname,
  isItemLive: state.auction.item.settings.liveNow,
  eventType_ID: state.auction.item.eventType_ID,
  event_ID: state.auction.item.event_ID,
});

export default connect(mapStateToProps, {})(Breadcrumb);
